<template>
  <v-dialog
    v-model="show"
    max-width="560"
    overlay-color="darktext"
    overlay-opacity="0.6"
  >
    <v-card>
      <v-card-title class="no-break">
        {{ cdTitle }}
      </v-card-title>
      
      <v-card-text >       
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn(title)"
          @submit.prevent
        >
          <v-text-field
            v-model="title"
            data-testid="dialog-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2 pt-4"
            :placeholder="cdInputPlaceholder"
            :rules="titleRules"
          />
          <p class="darktext--text ma-0 ml-10">{{ checkboxTitle }}</p>
          <v-checkbox
              v-model="checked"
              data-testid="dialog-checkbox"
              color="accent"
              class="black--text option rounded-xxl ma-0 ml-10 mb-4"
              :class="{ 'selected' : checked}"
              hide-details
            >
              <template v-slot:label>
                <div>
                  <span class="text-subtitle-2 grey--text font-weight-regular">{{ checkboxLabel }}</span> 
                </div>
              </template>
            </v-checkbox>
          <v-card-actions>
            <v-spacer />
            <v-btn
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              @click="show=false"
            >
              {{ cdCancelBtn }}
            </v-btn>
            <v-btn
              ref="submit"
              data-testid="submit-button"
              type="submit"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              :loading="loading"
              @click="Object.keys(item).length > 0 ? edit(title, checked) : submitDialogBtn(title, checked)"
            >
              {{ cdSubmitBtn }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired, ruleValidMin2Max70Characters } from '../rules/formRules.js';
import i18n from '../plugins/i18n.js';

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
    cdInputPlaceholder: {
      type: String,
      default: ''
    },
    checkboxLabel: {
      type: String,
      default: ''
    },
    checkboxTitle: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
        return{
          valid: true,
          titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
          title: '',
          alertMsg: '',
          loading: false,
          checked: false
         }
    },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
          this.$refs.form.reset()
        }
      }
    }
  },
  created(){
    if(Object.keys(this.item).length > 0){
      this.title = this.item.attributes.title
    }
  },
  methods: {
    submitDialogBtn(title, checked) {
      this.valid = this.$refs.form.validate()
      if(this.valid){
        this.loading = true
        this.$emit('proceedSubmit',title, checked)
      }
    },
    async edit(title, checked){
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.loading = true
        this.$emit("edit",title, checked);
      }
    },
  },
}
</script>